import {
  clearPendingVerificationEmailOnActivation,
  consumePendingVerificationEmailFromUrl,
} from '@/Domain/utils/pendingVerificationEmail';

consumePendingVerificationEmailFromUrl();
clearPendingVerificationEmailOnActivation();
